import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, TextField, InputAdornment, Button, CircularProgress, Typography, FormLabel, } from '@mui/material';
import { useTranslation } from 'react-i18next';
export default function GiftCardInput({ giftCardCode, setGiftCardCode, handleApplyGiftCard, isApplyingPromo, giftCardError, }) {
    const { t } = useTranslation();
    return (_jsxs(Box, { mt: 3, children: [_jsx(FormLabel, { sx: {
                    fontWeight: 'bold',
                    color: 'var(--secondaryFgColor)!important',
                    marginBottom: '0.5rem',
                    display: 'block',
                }, children: t('giftCardInput.title') }), _jsx(TextField, { variant: "filled", fullWidth: true, value: giftCardCode, onChange: (e) => setGiftCardCode(e.target.value), placeholder: t('giftCardInput.placeholder'), InputProps: {
                    endAdornment: (_jsx(InputAdornment, { position: "end", children: _jsx(Button, { onClick: handleApplyGiftCard, disabled: isApplyingPromo, sx: {
                                color: 'var(--secondaryFgColor)!important',
                                border: '1px solid var(--secondaryFgColor)!important',
                                padding: '0.5rem 1rem',
                                borderRadius: '4px',
                                textTransform: 'none',
                                fontWeight: 'bold',
                                '&:hover': {
                                    opacity: 0.8,
                                },
                            }, children: isApplyingPromo ? _jsx(CircularProgress, { size: 24 }) : t('giftCardInput.apply') }) })),
                }, sx: {
                    '& .MuiFilledInput-root': {
                        backgroundColor: 'var(--primaryBgColor)!important',
                        border: '1px solid var(--secondaryFgColor)!important',
                        borderRadius: '8px',
                        color: 'var(--secondaryFgColor)!important',
                    },
                    '& .MuiInputBase-input': {
                        padding: '1rem',
                    },
                } }), giftCardError && (_jsx(Typography, { variant: "body2", color: "error", sx: {
                    marginTop: '0.5rem',
                }, children: giftCardError }))] }));
}
